export default {
	title: {
		firstPart: 'Espace',
		secondPart: 'J\'attends un enfant'
	},
	calendrier : {
		bouton : {
			label: 'Mon calendrier de suivi',
			title: 'Accéder à mon calendrier de suivi'
		}
	},
	datePresumee : 'Date présumée de mon accouchement',
	periodeEnCours : 'Vous êtes | Vous en êtes au | Vous en êtes au',
	periodes : [
		{
			label : 'Avant la fin du 3<sup>ème</sup> mois',
			moisAffichage: '2',
			moisMax : 3
		},
		{
			label : '4<sup>ème</sup> mois',
			moisAffichage: '3',
			moisMax : 4
		},
		{
			label : '5<sup>ème</sup> mois',
			moisAffichage: '4',
			moisMax : 5
		},
		{
			label : '6<sup>ème</sup> mois',
			moisAffichage: '5',
			moisMax : 6
		},
		{
			label : '7<sup>ème</sup> mois',
			moisAffichage: '6',
			moisMax : 7
		},
		{
			label : '8<sup>ème</sup> mois',
			moisAffichage: '7',
			moisMax : 8
		},
		{
			label : '9<sup>ème</sup> mois',
			moisAffichage: '8',
			moisMax : 10
		}
	]
}
